<template>
  <div class="py-4 sidebar">
    <div class="mb-3 filter-row">
      <Datepicker
        :clickCloseContent="false"
        showIconCalendar
        isClearable
        :show="menu"
        :date="date"
        :isIconDown="false"
        :placeholder="'DD/MM/YYYY'"
        @date-change="changeDate"
      />
      <v-select
        v-model="filterUnit"
        :items="units"
        dense
        hide-details
        outlined
        clearable
        placeholder="Pilih poli"
        item-text="text"
        item-value="value"
        style="min-width: 50px"
        class="responsive-select"
        @change="handleChangeFilter"
      />
      <v-btn
        color="primary"
        outlined
        class="text-none responsive-btn"
        @click="closeAllHistoryPanel"
      >
        <div class="text-btn">
          {{ buttonAction }}
        </div>
      </v-btn>
    </div>

    <label class="grey--text" v-if="data.length < 1 && !isLoading && !mini">
      Tidak ada riwayat yang ditemukan
    </label>

    <div
      v-if="!mini"
      class="sidebar-history-container"
      @scroll="handleScroll"
      ref="scrollContainer"
    >
      <template v-if="isLoading && data.length === 0">
        <v-skeleton-loader
          v-for="n in 3"
          :key="`skeleton-${n}`"
          class="mb-3"
          type="article"
        />
      </template>

      <!-- History cards -->
      <history-card
        ref="historyCards"
        class="mb-2"
        :data="item"
        v-for="(item, index) in data"
        :key="`card-${item.id || index}`"
        :header-data="headerData"
        @panel-open="handlePanelOpen"
        @panel-close="closePanelAction"
      />

      <!-- Loading more indicator -->
      <div v-if="isLoadingMore" class="text-center py-3">
        <v-progress-circular indeterminate color="primary" size="24" />
        <p class="grey--text mt-2">Memuat lebih banyak...</p>
      </div>

      <!-- No more data indicator -->
      <!-- <div v-if="!hasMoreData && data.length > 0" class="text-center py-3">
        <p class="grey--text">Tidak ada data lagi</p>
      </div> -->
    </div>
  </div>
</template>

<script>
import HistoryCard from './HistoryCardV2.vue';
import Datepicker from '@/components/SharedComponent/Datepicker/Datepicker.vue';
import moment from 'moment-timezone';
import { getAllUnit } from '../../../../fetchApi/MasterData/Unit';

import Constant from '@/const';
const axios = require('axios');

export default {
  name: 'HistorySidebarVisitTab',
  components: {
    HistoryCard,
    Datepicker,
  },
  props: {
    headerData: {
      type: Object,
      default: null,
    },
  },
  computed: {
    isLargeDisplay() {
      return this.$vuetify.breakpoint.name === 'xl';
    },
    isAdult() {
      const birthDate = moment(
        this.$store.getters.selectedPatient.meta.birthDate,
        'DD MMMM YYYY',
      );
      const diff = moment().diff(birthDate, 'month');
      return diff > 228;
    },
  },
  data() {
    return {
      buttonAction: 'Tutup Semua',
      renderCard: false,
      menu: false,
      date: '',
      filterDate: null,
      filterUnit: null,
      units: [],
      mini: false,
      drawer: true,
      isLoading: false,
      isLoadingMore: false,
      data: [],
      currentPage: 1,
      itemsPerPage: 3,
      hasMoreData: true,
      totalItems: 0,
    };
  },
  mounted() {
    this.showAllHistory();
    this.getUnit();
  },
  methods: {
    async getUnit() {
      try {
        const response = await getAllUnit({
          installation: 'Instalasi Rawat Jalan',
        });
        const { data } = response;
        this.units = data.map(v => {
          return {
            text: v.name,
            value: v._id,
          };
        });
      } catch (error) {
        this.units = [];
      }
    },

    changeDate(value) {
      this.date = value === null ? '' : value;
      this.handleChangeFilter();
    },

    handleChangeFilter() {
      // Reset pagination when filters change
      this.currentPage = 1;
      this.data = [];
      this.hasMoreData = true;

      const unit = this.filterUnit || '';
      const date = this.date;

      this.showAllHistory(unit, date, true);
    },

    handleScroll(event) {
      const { target } = event;
      const { scrollTop, scrollHeight, clientHeight } = target;

      const threshold = 50;
      const isAtBottom = scrollTop + clientHeight >= scrollHeight - threshold;

      if (isAtBottom && !this.isLoadingMore && this.hasMoreData) {
        this.loadMoreData();
      }
    },

    async loadMoreData() {
      if (this.isLoadingMore || !this.hasMoreData) return;

      this.currentPage += 1;
      const unit = this.filterUnit || '';
      const date = this.date;

      await this.showAllHistory(unit, date, false);
    },

    async showAllHistory(unit = '', date = '', isNewSearch = false) {
      if (isNewSearch) {
        this.isLoading = true;
        this.isLoadingMore = false;
      } else {
        this.isLoadingMore = true;
      }

      try {
        const response = await axios.get(
          Constant.apiUrl
            .concat(
              `/visit-history/${this.$store.getters.selectedPatient.id_emr}`,
            )
            .concat(`?id_unit=${unit}`)
            .concat(`&startDateCreated=${date}`)
            .concat(`&endDateCreated=${date}`)
            .concat(`&page=${this.currentPage}`)
            .concat(`&itemCount=${this.itemsPerPage}`),
        );

        const { data, total, currentPage, totalPages } = response.data;
        const mappedData = this.mapHistory(data);

        if (isNewSearch) {
          this.data = mappedData;
        } else {
          this.data = [...this.data, ...mappedData];
        }

        this.totalItems = total || 0;
        this.hasMoreData =
          currentPage < totalPages || data.length === this.itemsPerPage;

        if (data.length < this.itemsPerPage) {
          this.hasMoreData = false;
        }
        this.buttonAction = 'Tutup Semua';
      } catch (error) {
        this.hasMoreData = false;
      } finally {
        this.isLoading = false;
        this.isLoadingMore = false;
      }
    },

    mapHistory(data) {
      const result = data.map((v, i) => {
        return {
          ...v,
          index: i,
          id_registration: v.id_registration,
          date: moment(v.created_at).format('DD MMMM YYYY'),
          time: moment(v.created_at).format('HH:mm'),
          imt: {
            text: v?.nutrition_screening.imt,
            color: this.imtChipDecision(v.nutrition_screening.imt),
          },
          nutritionScreening: {
            text: v?.nutrition_screening.result,
            color: this.nutritionScreeningResult(v.nutrition_screening.result),
          },
          fallRisk: {
            text: v?.assesment.fall_risk_result,
            color: this.fallRiskResult(v?.assesment.fall_risk_result),
          },
        };
      });
      return result;
    },

    fallRiskResult(text = null) {
      let color = 'green';
      if (!text) return color;

      if (text === 'Risiko Jatuh Rendah') {
        color = 'yellow';
      } else if (text === 'Risiko Jatuh Tinggi') {
        color = 'red';
      }

      return color;
    },

    nutritionScreeningResult(text = null) {
      let color = 'green';
      if (!text) return color;

      if (text === 'Risiko Malnutrisi' || text === 'Berisiko Sedang') {
        color = 'yellow';
      } else if (text === 'Malnutrisi' || text === 'Berisiko Tinggi') {
        color = 'red';
      }

      return color;
    },

    imtChipDecision(text) {
      let color = 'green';
      if (!text) return color;

      switch (text.toLowerCase()) {
        case 'gizi buruk':
        case 'underweight':
        case 'obesitas':
        case 'obesity':
          color = 'red';
          break;
        case 'gizi kurang':
        case 'gizi lebih':
        case 'overweight':
          color = 'yellow';
          break;
        case 'berisiko gizi lebih':
          color = 'light-yellow';
          break;
      }
      return color;
    },

    handlePanelOpen() {
      this.buttonAction = 'Tutup Semua';
    },

    closePanelAction() {
      const panelOpen = [];
      this.$refs.historyCards.forEach(card => {
        panelOpen.push(card.expand);
      });

      if (panelOpen.find(v => v === 0)) this.buttonAction = 'Tutup Semua';
      else this.buttonAction = 'Buka Semua';
    },

    closeAllHistoryPanel() {
      if (this.$refs.historyCards) {
        const allCloseBtn = this.buttonAction === 'Tutup Semua';

        this.$refs.historyCards.forEach(card => {
          if (allCloseBtn) {
            if (card.closePanel) {
              card.closePanel();
            }
          } else {
            if (card.openPanel) {
              card.openPanel();
            }
          }
        });

        if (allCloseBtn) this.buttonAction = 'Buka Semua';
        else this.buttonAction = 'Tutup Semua';
      }
    },
  },
};
</script>

<style scoped lang="scss">
.filter-row {
  width: 100%;
  display: grid;
  grid-template-columns: 0.5fr 0.5fr 0.4fr;
  column-gap: 0.5vw;

  > * {
    height: 40px;
  }
}

.sidebar {
  height: 94vh; // Give the sidebar a fixed height
  display: flex;
  flex-direction: column;

  &-history-container {
    flex: 1; // Take remaining space
    overflow-y: auto; // Enable scrolling
    max-height: calc(94vh - 200px); // Adjust based on your header/filter height
    padding: 0 8px 0 0; // Add some padding

    &::-webkit-scrollbar {
      width: 6px;
      background-color: #f1f1f1;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #c1c1c1;
      border-radius: 3px;

      &:hover {
        background-color: #a8a8a8;
      }
    }
  }

  &-title {
    margin-right: 6rem;
    padding-left: 0.8rem;
  }

  &-history {
    display: block;
    padding: 0px;
  }
}

.responsive-select {
  min-width: 140px;

  ::v-deep .v-input__control {
    min-height: 40px !important;
  }

  ::v-deep .v-select__selections {
    font-size: 14px;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    max-width: 100%;
  }
}

.responsive-btn {
  height: 40px !important;
  min-width: 100px;
  font-size: 0.8vw !important;
  padding: 0 16px !important;
}

@media screen and (max-width: 1366px) {
  .filter-row {
    gap: 8px;

    > * {
      height: 36px;
    }
  }

  .responsive-select {
    min-width: 100px;

    ::v-deep .v-input__control {
      min-height: 36px !important;
    }

    ::v-deep .v-select__selection {
      font-size: 12px;
    }
  }

  .responsive-btn {
    height: 36px !important;
    min-width: 80px;
    font-size: 11px !important;
    padding: 0 10px !important;
  }
}

@media screen and (max-width: 1024px) {
  .filter-row {
    grid-template-columns: 1fr;
    gap: 8px;
  }

  .responsive-select,
  .responsive-btn {
    width: 100%;
  }
}
</style>
